import { Main } from "./main";
import "styles/header.css";

export const History = () => {
  return (
    <>
      <Main />
    </>
  );
};
